import { AnimatePresence, motion } from "framer-motion";
export function TransitionLabel({
  visible,
  label
}: {
  visible: boolean;
  label: string;
}) {
  return <div className="pointer-events-none absolute inset-x-0 bottom-2 flex justify-center px-5" data-id="element-123" data-mp="3agh9zn5wp9el">
      <AnimatePresence data-id="element-124" data-mp="3f9adk7pn2bp3">
        {visible && label && <motion.p key={label} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-full bg-[var(--s-bg)] px-3 py-1 font-display text-[13px] italic text-[var(--s-muted)]" aria-live="polite" data-id="element-125" data-mp="3javldenbfzsf">
            {label}
          </motion.p>}
      </AnimatePresence>
    </div>;
}